import * as React from "react";
const SvgFiRrToiletPaperSlash = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-toilet-paper-slash_svg__a)">
      <path
        fill="#062147"
        d="M15.843 20.25A5 5 0 0 1 11 24H2.653A2.656 2.656 0 0 1 0 21.347c0-1.089.684-2.066 1.741-2.488a1.99 1.99 0 0 0 1.26-1.858v-8a1 1 0 1 1 2 0v8a3.98 3.98 0 0 1-2.518 3.716c-.234.093-.483.308-.483.631 0 .36.293.653.653.653H11c1.37 0 2.564-.925 2.905-2.249.138-.535.69-.856 1.218-.72a1 1 0 0 1 .72 1.217M18 8.5c0 1.381.448 2.5 1 2.5s1-1.119 1-2.5c0-1.38-.448-2.5-1-2.5s-1 1.12-1 2.5m5.707 13.793a.999.999 0 1 1-1.414 1.414l-22-22A.999.999 0 1 1 1.707.293l2.421 2.421C5.06 1.011 6.466 0 8 0h11c2.804 0 5 3.733 5 8.5S21.804 17 19 17h-.586zM19 2c-1.419 0-3 2.67-3 6.5s1.581 6.5 3 6.5 3-2.67 3-6.5S20.42 2 19 2M5.623 4.21 14 12.585V8.5c0-2.634.671-4.953 1.745-6.5H8c-.898 0-1.8.853-2.377 2.21"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-toilet-paper-slash_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToiletPaperSlash;
